import React from 'react';
import { getColor, typeScale } from 'core/utils';
import styled from 'styled-components';
import { featuredCardProps } from 'core/utils';
import ArrowRight from 'core/icons/ArrowRight';
import { size } from 'styled-manila';

export const Card = styled.a`
	background: ${getColor("white")};
	box-shadow: 3px 6px 10px 0 rgba(0,0,0,0.10);
	border-radius: ${typeScale(2)};
	overflow: hidden;
	display: block;
	color: ${getColor("gray")};
	position: relative;

	@media (min-width: 768px) {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}
`;

export const Picture = styled.img`
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover;
`;

export const Figure = styled.figure`
	@media (min-width: 768px) {
		max-height: 450px;
		order: 1;
	}
`;

export const Subtitle = styled.p`
	margin: 0;
	font-size: 12px;
	letter-spacing: 1px;
	line-height: 1;
	text-transform: uppercase;
	margin-bottom: ${typeScale(1)};

	@media (min-width: 768px) {
		margin-bottom: ${typeScale(2)};
	}

	@media (min-width: 1024px) {
		margin-bottom: ${typeScale(3)};
	}
`;

export const Title = styled.h3`
	margin: 0;
	font-weight: 700;
	@media (min-width: 768px) {
		font-size: ${typeScale(4)};
	}

	@media (min-width: 1024px) {
		font-size: ${typeScale(5)};
	}
`;

export const Info = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: ${typeScale(2)};

	@media (min-width: 768px) {
		padding: ${typeScale(4)};
	}

	@media (min-width: 768px) {
		padding: ${typeScale(5)};
	}
`;

export const Cta = styled.p`
	margin: 0;
	font-weight: 600;
	font-size: 18px;
	letter-spacing: -0.3px;
	line-height: 1;
	margin-top: ${typeScale(3)};

	> svg {
		margin-left: 5px;
		vertical-align: middle;
		${size('0.6em')};
	}

	@media (min-width: 768px) {
		margin-top: ${typeScale(4)};
	}
`;

const BlogCard = ({
	title, subTitle, image, link, cta
}) => (
	<Card href={link} title={title}>
		<Figure>
			<Picture src={image} alt={title} />
		</Figure>
		<Info>
			{subTitle && <Subtitle>{subTitle}</Subtitle>}
			<Title>{ title }</Title>

			{link && cta && (
				<Cta>
					{cta}
					<ArrowRight fill="currentColor" />
				</Cta>
			)}
		</Info>
	</Card>
);

BlogCard.propTypes = featuredCardProps;
BlogCard.defaultProps = {};

export default BlogCard;
